import React, { createRef, FocusEvent, forwardRef, useImperativeHandle } from "react";
import { ActionHandlerFunction } from "@preveil-api";
import { DirectoryEntity, DriveErrorMessages, DriveUIActionTypes } from "src/common";

type AllProps = {
  current_directory?: DirectoryEntity;
  handleAction: ActionHandlerFunction;
}

const FileUploadComponent = forwardRef(function FileUploadComponent(props: AllProps, ref) {
  const { current_directory, handleAction } = props;
  const file_ref = createRef<HTMLInputElement>();

  useImperativeHandle(ref, () => {
    return {
      click() {
        !!file_ref.current ? file_ref.current.click() : console.error(DriveErrorMessages.error_opening_editor_file_upload);
      }
    };
  });

  // Description: Pass selected files to upload hook
  function handleAddFiles(e: FocusEvent<HTMLInputElement>) {
    const files = e.target.files;
    if (!!files && files.length > 0) {
      handleAction({ actionType: DriveUIActionTypes.Upload, params: { destination_id: current_directory?.id, files } });
    }
    if (!!file_ref.current) {
      file_ref.current.value = "";
    }
  }

  return <input ref={file_ref} className="d-none" multiple type="file" onChange={handleAddFiles} />;
});

export default React.memo(FileUploadComponent);
